import React from 'react'

function NovaPropostaModeloProposta() {
  return (
    <div style={{padding: '10rem'}}>NovaPropostaModeloProposta</div>
  )
}

export default NovaPropostaModeloProposta
